import { useMutation, useQueryClient } from "@tanstack/react-query";
import { payerService } from "../../services/payer.service";
import {
	CreatePayer,
	DeletePayer,
	UpdatePayer,
} from "@/domain/payer.interface";

export const useCreatePayer = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: CreatePayer) => payerService.createPayer(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["payers"] });
		},
	});
};

export const useUpdatePayer = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: UpdatePayer) => payerService.updatePayer(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["payers"] });
		},
	});
};

export const useDeletePayer = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: DeletePayer) => payerService.deletePayer(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["payers"] });
		},
	});
};
